module.exports = __webpack_public_path__ + "img/travincal-run.2c1661a7.png";